var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 933,
    height: 4431,
    viewBox: "0 0 933 4431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521 2796L521 2974",
    stroke: "url(#paint0_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 2885H610",
    stroke: "url(#paint1_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 2876H788",
    stroke: "url(#paint2_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 2876H281",
    stroke: "url(#paint3_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 2894H788",
    stroke: "url(#paint4_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 2894H281",
    stroke: "url(#paint5_linear_258_567)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.292 136.767C649.302 153.937 672.323 232.631 630.065 267.112C587.808 301.593 496.275 278.802 482.264 261.632C468.254 244.463 458.711 213.322 500.969 178.841C540.759 141.46 621.282 119.597 635.292 136.767Z",
    fill: "url(#paint6_linear_258_567)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581 3648L581 3826",
    stroke: "url(#paint7_linear_258_567)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492 3737H670",
    stroke: "url(#paint8_linear_258_567)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M670 3728H848",
    stroke: "url(#paint9_linear_258_567)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519 3728H341",
    stroke: "url(#paint10_linear_258_567)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M670 3746H848",
    stroke: "url(#paint11_linear_258_567)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M519 3746H341",
    stroke: "url(#paint12_linear_258_567)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241 3648L241 3826",
    stroke: "url(#paint13_linear_258_567)",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152 3737H330",
    stroke: "url(#paint14_linear_258_567)",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M330 3728H508",
    stroke: "url(#paint15_linear_258_567)",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179 3728H1",
    stroke: "url(#paint16_linear_258_567)",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330 3746H508",
    stroke: "url(#paint17_linear_258_567)",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179 3746H1",
    stroke: "url(#paint18_linear_258_567)",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241 3253L241 3431",
    stroke: "url(#paint19_linear_258_567)",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152 3342H330",
    stroke: "url(#paint20_linear_258_567)",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330 3333H508",
    stroke: "url(#paint21_linear_258_567)",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179 3333H1",
    stroke: "url(#paint22_linear_258_567)",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M330 3351H508",
    stroke: "url(#paint23_linear_258_567)",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179 3351H1",
    stroke: "url(#paint24_linear_258_567)",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M581 3253L581 3431",
    stroke: "url(#paint25_linear_258_567)",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M492 3342H670",
    stroke: "url(#paint26_linear_258_567)",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M670 3333H848",
    stroke: "url(#paint27_linear_258_567)",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M519 3333H341",
    stroke: "url(#paint28_linear_258_567)",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M670 3351H848",
    stroke: "url(#paint29_linear_258_567)",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M519 3351H341",
    stroke: "url(#paint30_linear_258_567)",
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 2627L255 2805",
    stroke: "url(#paint31_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 2716H344",
    stroke: "url(#paint32_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 2707H522",
    stroke: "url(#paint33_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 2707H15",
    stroke: "url(#paint34_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 2725H522",
    stroke: "url(#paint35_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 2725H15",
    stroke: "url(#paint36_linear_258_567)",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303 533L303 711",
    stroke: "url(#paint37_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 622H392",
    stroke: "url(#paint38_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 613H570",
    stroke: "url(#paint39_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 613H63",
    stroke: "url(#paint40_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 631H570",
    stroke: "url(#paint41_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 631H63",
    stroke: "url(#paint42_linear_258_567)",
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543 863L543 1041",
    stroke: "url(#paint43_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 952H632",
    stroke: "url(#paint44_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 943H810",
    stroke: "url(#paint45_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 943H303",
    stroke: "url(#paint46_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 961H810",
    stroke: "url(#paint47_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 961H303",
    stroke: "url(#paint48_linear_258_567)",
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 2197L255 2375",
    stroke: "url(#paint49_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 2286H344",
    stroke: "url(#paint50_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 2277H522",
    stroke: "url(#paint51_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 2277H15",
    stroke: "url(#paint52_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 2295H522",
    stroke: "url(#paint53_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 2295H15",
    stroke: "url(#paint54_linear_258_567)",
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 159L255 337",
    stroke: "url(#paint55_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 248H344",
    stroke: "url(#paint56_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 239H522",
    stroke: "url(#paint57_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 239H15",
    stroke: "url(#paint58_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 257H522",
    stroke: "url(#paint59_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 257H15",
    stroke: "url(#paint60_linear_258_567)",
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555 199L555 377",
    stroke: "url(#paint61_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 288H644",
    stroke: "url(#paint62_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 279H822",
    stroke: "url(#paint63_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 279H315",
    stroke: "url(#paint64_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 297H822",
    stroke: "url(#paint65_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 297H315",
    stroke: "url(#paint66_linear_258_567)",
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585 2057L585 2235",
    stroke: "url(#paint67_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 2146H674",
    stroke: "url(#paint68_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674 2137H852",
    stroke: "url(#paint69_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 2137H345",
    stroke: "url(#paint70_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674 2155H852",
    stroke: "url(#paint71_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 2155H345",
    stroke: "url(#paint72_linear_258_567)",
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278 1867L278 2045",
    stroke: "url(#paint73_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 1956H367",
    stroke: "url(#paint74_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 1947H545",
    stroke: "url(#paint75_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 1947H38",
    stroke: "url(#paint76_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 1965H545",
    stroke: "url(#paint77_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 1965H38",
    stroke: "url(#paint78_linear_258_567)",
    strokeLinecap: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511 1537L511 1715",
    stroke: "url(#paint79_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 1626H600",
    stroke: "url(#paint80_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 1617H778",
    stroke: "url(#paint81_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 1617H271",
    stroke: "url(#paint82_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 1635H778",
    stroke: "url(#paint83_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 1635H271",
    stroke: "url(#paint84_linear_258_567)",
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274 1207L274 1385",
    stroke: "url(#paint85_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 1296H363",
    stroke: "url(#paint86_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 1287H541",
    stroke: "url(#paint87_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 1287H34",
    stroke: "url(#paint88_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 1305H541",
    stroke: "url(#paint89_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 1305H34",
    stroke: "url(#paint90_linear_258_567)",
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397 2374L397 2552",
    stroke: "url(#paint91_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 2463H486",
    stroke: "url(#paint92_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 2454H664",
    stroke: "url(#paint93_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 2454H157",
    stroke: "url(#paint94_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 2472H664",
    stroke: "url(#paint95_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 2472H157",
    stroke: "url(#paint96_linear_258_567)",
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.093 3903.36C635.562 3930.9 672.481 4057.11 604.71 4112.41C536.94 4167.71 390.142 4131.16 367.673 4103.62C345.204 4076.08 329.899 4026.14 397.67 3970.84C461.484 3910.89 590.624 3875.83 613.093 3903.36Z",
    fill: "url(#paint97_linear_258_567)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.049 822.004C453.388 849.382 490.095 974.863 422.715 1029.84C355.334 1084.82 209.381 1048.48 187.041 1021.11C164.702 993.729 149.485 944.073 216.866 889.092C280.313 829.487 408.709 794.626 431.049 822.004Z",
    fill: "url(#paint98_linear_258_567)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter3_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.801 1596.6C337.534 1618.33 366.673 1717.94 313.185 1761.59C259.697 1805.23 143.838 1776.38 126.105 1754.65C108.371 1732.92 96.2922 1693.5 149.78 1649.86C200.145 1602.54 302.067 1574.87 319.801 1596.6Z",
    fill: "url(#paint99_linear_258_567)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.801 2014.6C584.534 2036.33 613.673 2135.94 560.185 2179.59C506.697 2223.23 390.838 2194.38 373.105 2172.65C355.371 2150.92 343.292 2111.5 396.78 2067.86C447.145 2020.54 549.067 1992.87 566.801 2014.6Z",
    fill: "url(#paint100_linear_258_567)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter5_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.801 1176.6C619.534 1198.33 648.673 1297.94 595.185 1341.59C541.697 1385.23 425.838 1356.38 408.105 1334.65C390.371 1312.92 378.292 1273.5 431.78 1229.86C482.145 1182.54 584.067 1154.87 601.801 1176.6Z",
    fill: "url(#paint101_linear_258_567)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter6_f_258_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.801 323.601C371.534 345.334 400.673 444.942 347.185 488.587C293.697 532.231 177.838 503.384 160.105 481.651C142.371 459.918 130.292 420.501 183.78 376.857C234.145 329.542 336.067 301.868 353.801 323.601Z",
    fill: "url(#paint102_linear_258_567)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326 1H504",
    stroke: "url(#paint103_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 90H415",
    stroke: "url(#paint104_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 81H593",
    stroke: "url(#paint105_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 81H86",
    stroke: "url(#paint106_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 99H593",
    stroke: "url(#paint107_linear_258_567)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 99H86",
    stroke: "url(#paint108_linear_258_567)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_258_567",
    x: 390.373,
    y: 50.8232,
    width: 343.901,
    height: 314.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_258_567",
    x: 59.6016,
    y: 3604.83,
    width: 872.935,
    height: 825.361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 144.5,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_258_567",
    x: 88.0801,
    y: 732.526,
    width: 453.237,
    height: 405.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_258_567",
    x: 31.0531,
    y: 1509.08,
    width: 392.775,
    height: 355.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_258_567",
    x: 278.053,
    y: 1927.08,
    width: 392.775,
    height: 355.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_258_567",
    x: 313.053,
    y: 1089.08,
    width: 392.775,
    height: 355.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_258_567",
    x: 65.0531,
    y: 236.078,
    width: 392.775,
    height: 355.228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_258_567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_567",
    x1: 520.5,
    y1: 2796,
    x2: 520.5,
    y2: 2974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_567",
    x1: 432,
    y1: 2885.5,
    x2: 610,
    y2: 2885.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_258_567",
    x1: 610,
    y1: 2876.5,
    x2: 788,
    y2: 2876.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_258_567",
    x1: 459,
    y1: 2876.5,
    x2: 281,
    y2: 2876.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_258_567",
    x1: 610,
    y1: 2894.5,
    x2: 788,
    y2: 2894.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_258_567",
    x1: 459,
    y1: 2894.5,
    x2: 281,
    y2: 2894.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_258_567",
    x1: 492.131,
    y1: 273.725,
    x2: 645.159,
    y2: 148.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#0075FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_258_567",
    x1: 580.5,
    y1: 3648,
    x2: 580.5,
    y2: 3826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_258_567",
    x1: 492,
    y1: 3737.5,
    x2: 670,
    y2: 3737.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_258_567",
    x1: 670,
    y1: 3728.5,
    x2: 848,
    y2: 3728.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_258_567",
    x1: 519,
    y1: 3728.5,
    x2: 341,
    y2: 3728.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_258_567",
    x1: 670,
    y1: 3746.5,
    x2: 848,
    y2: 3746.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_258_567",
    x1: 519,
    y1: 3746.5,
    x2: 341,
    y2: 3746.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_258_567",
    x1: 240.5,
    y1: 3648,
    x2: 240.5,
    y2: 3826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_258_567",
    x1: 152,
    y1: 3737.5,
    x2: 330,
    y2: 3737.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_258_567",
    x1: 330,
    y1: 3728.5,
    x2: 508,
    y2: 3728.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_258_567",
    x1: 179,
    y1: 3728.5,
    x2: 1,
    y2: 3728.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_258_567",
    x1: 330,
    y1: 3746.5,
    x2: 508,
    y2: 3746.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_258_567",
    x1: 179,
    y1: 3746.5,
    x2: 1,
    y2: 3746.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_258_567",
    x1: 240.5,
    y1: 3253,
    x2: 240.5,
    y2: 3431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_258_567",
    x1: 152,
    y1: 3342.5,
    x2: 330,
    y2: 3342.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_258_567",
    x1: 330,
    y1: 3333.5,
    x2: 508,
    y2: 3333.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_258_567",
    x1: 179,
    y1: 3333.5,
    x2: 1,
    y2: 3333.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_258_567",
    x1: 330,
    y1: 3351.5,
    x2: 508,
    y2: 3351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_258_567",
    x1: 179,
    y1: 3351.5,
    x2: 1,
    y2: 3351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_258_567",
    x1: 580.5,
    y1: 3253,
    x2: 580.5,
    y2: 3431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_258_567",
    x1: 492,
    y1: 3342.5,
    x2: 670,
    y2: 3342.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_258_567",
    x1: 670,
    y1: 3333.5,
    x2: 848,
    y2: 3333.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_258_567",
    x1: 519,
    y1: 3333.5,
    x2: 341,
    y2: 3333.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_258_567",
    x1: 670,
    y1: 3351.5,
    x2: 848,
    y2: 3351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_258_567",
    x1: 519,
    y1: 3351.5,
    x2: 341,
    y2: 3351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_258_567",
    x1: 254.5,
    y1: 2627,
    x2: 254.5,
    y2: 2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_258_567",
    x1: 166,
    y1: 2716.5,
    x2: 344,
    y2: 2716.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_258_567",
    x1: 344,
    y1: 2707.5,
    x2: 522,
    y2: 2707.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_258_567",
    x1: 193,
    y1: 2707.5,
    x2: 15,
    y2: 2707.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_258_567",
    x1: 344,
    y1: 2725.5,
    x2: 522,
    y2: 2725.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_258_567",
    x1: 193,
    y1: 2725.5,
    x2: 15,
    y2: 2725.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_258_567",
    x1: 302.5,
    y1: 533,
    x2: 302.5,
    y2: 711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_258_567",
    x1: 214,
    y1: 622.5,
    x2: 392,
    y2: 622.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_258_567",
    x1: 392,
    y1: 613.5,
    x2: 570,
    y2: 613.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_258_567",
    x1: 241,
    y1: 613.5,
    x2: 63,
    y2: 613.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_258_567",
    x1: 392,
    y1: 631.5,
    x2: 570,
    y2: 631.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_258_567",
    x1: 241,
    y1: 631.5,
    x2: 63,
    y2: 631.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_258_567",
    x1: 542.5,
    y1: 863,
    x2: 542.5,
    y2: 1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_258_567",
    x1: 454,
    y1: 952.5,
    x2: 632,
    y2: 952.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_258_567",
    x1: 632,
    y1: 943.5,
    x2: 810,
    y2: 943.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_258_567",
    x1: 481,
    y1: 943.5,
    x2: 303,
    y2: 943.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_258_567",
    x1: 632,
    y1: 961.5,
    x2: 810,
    y2: 961.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_258_567",
    x1: 481,
    y1: 961.5,
    x2: 303,
    y2: 961.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_258_567",
    x1: 254.5,
    y1: 2197,
    x2: 254.5,
    y2: 2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_258_567",
    x1: 166,
    y1: 2286.5,
    x2: 344,
    y2: 2286.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_258_567",
    x1: 344,
    y1: 2277.5,
    x2: 522,
    y2: 2277.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_258_567",
    x1: 193,
    y1: 2277.5,
    x2: 15,
    y2: 2277.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_258_567",
    x1: 344,
    y1: 2295.5,
    x2: 522,
    y2: 2295.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_258_567",
    x1: 193,
    y1: 2295.5,
    x2: 15,
    y2: 2295.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_258_567",
    x1: 254.5,
    y1: 159,
    x2: 254.5,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_258_567",
    x1: 166,
    y1: 248.5,
    x2: 344,
    y2: 248.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_258_567",
    x1: 344,
    y1: 239.5,
    x2: 522,
    y2: 239.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_258_567",
    x1: 193,
    y1: 239.5,
    x2: 15,
    y2: 239.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_258_567",
    x1: 344,
    y1: 257.5,
    x2: 522,
    y2: 257.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_258_567",
    x1: 193,
    y1: 257.5,
    x2: 15,
    y2: 257.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_258_567",
    x1: 554.5,
    y1: 199,
    x2: 554.5,
    y2: 377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_258_567",
    x1: 466,
    y1: 288.5,
    x2: 644,
    y2: 288.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_258_567",
    x1: 644,
    y1: 279.5,
    x2: 822,
    y2: 279.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_258_567",
    x1: 493,
    y1: 279.5,
    x2: 315,
    y2: 279.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_258_567",
    x1: 644,
    y1: 297.5,
    x2: 822,
    y2: 297.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_258_567",
    x1: 493,
    y1: 297.5,
    x2: 315,
    y2: 297.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_258_567",
    x1: 584.5,
    y1: 2057,
    x2: 584.5,
    y2: 2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_258_567",
    x1: 496,
    y1: 2146.5,
    x2: 674,
    y2: 2146.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_258_567",
    x1: 674,
    y1: 2137.5,
    x2: 852,
    y2: 2137.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_258_567",
    x1: 523,
    y1: 2137.5,
    x2: 345,
    y2: 2137.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_258_567",
    x1: 674,
    y1: 2155.5,
    x2: 852,
    y2: 2155.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_258_567",
    x1: 523,
    y1: 2155.5,
    x2: 345,
    y2: 2155.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_258_567",
    x1: 277.5,
    y1: 1867,
    x2: 277.5,
    y2: 2045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_258_567",
    x1: 189,
    y1: 1956.5,
    x2: 367,
    y2: 1956.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_258_567",
    x1: 367,
    y1: 1947.5,
    x2: 545,
    y2: 1947.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_258_567",
    x1: 216,
    y1: 1947.5,
    x2: 38,
    y2: 1947.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_258_567",
    x1: 367,
    y1: 1965.5,
    x2: 545,
    y2: 1965.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_258_567",
    x1: 216,
    y1: 1965.5,
    x2: 38,
    y2: 1965.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_258_567",
    x1: 510.5,
    y1: 1537,
    x2: 510.5,
    y2: 1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_258_567",
    x1: 422,
    y1: 1626.5,
    x2: 600,
    y2: 1626.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_258_567",
    x1: 600,
    y1: 1617.5,
    x2: 778,
    y2: 1617.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_258_567",
    x1: 449,
    y1: 1617.5,
    x2: 271,
    y2: 1617.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_258_567",
    x1: 600,
    y1: 1635.5,
    x2: 778,
    y2: 1635.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_258_567",
    x1: 449,
    y1: 1635.5,
    x2: 271,
    y2: 1635.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_258_567",
    x1: 273.5,
    y1: 1207,
    x2: 273.5,
    y2: 1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_258_567",
    x1: 185,
    y1: 1296.5,
    x2: 363,
    y2: 1296.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_258_567",
    x1: 363,
    y1: 1287.5,
    x2: 541,
    y2: 1287.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_258_567",
    x1: 212,
    y1: 1287.5,
    x2: 34,
    y2: 1287.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_258_567",
    x1: 363,
    y1: 1305.5,
    x2: 541,
    y2: 1305.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_258_567",
    x1: 212,
    y1: 1305.5,
    x2: 34,
    y2: 1305.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_258_567",
    x1: 396.5,
    y1: 2374,
    x2: 396.5,
    y2: 2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_258_567",
    x1: 308,
    y1: 2463.5,
    x2: 486,
    y2: 2463.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_258_567",
    x1: 486,
    y1: 2454.5,
    x2: 664,
    y2: 2454.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_258_567",
    x1: 335,
    y1: 2454.5,
    x2: 157,
    y2: 2454.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_258_567",
    x1: 486,
    y1: 2472.5,
    x2: 664,
    y2: 2472.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_258_567",
    x1: 335,
    y1: 2472.5,
    x2: 157,
    y2: 2472.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_258_567",
    x1: 383.497,
    y1: 4123.01,
    x2: 628.917,
    y2: 3922.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#0BD5E3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_258_567",
    x1: 202.775,
    y1: 1040.39,
    x2: 446.782,
    y2: 841.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#616569",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_258_567",
    x1: 138.594,
    y1: 1769.96,
    x2: 332.29,
    y2: 1611.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#616569",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_258_567",
    x1: 427.848,
    y1: 2042.02,
    x2: 548.124,
    y2: 2189.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4AA6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#6A4AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#6A4AA6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_258_567",
    x1: 462.848,
    y1: 1204.03,
    x2: 583.124,
    y2: 1351.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4AA6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#6A4AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#6A4AA6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_258_567",
    x1: 214.848,
    y1: 351.025,
    x2: 335.124,
    y2: 498.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#285983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#285983",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_258_567",
    x1: 326,
    y1: 1.5,
    x2: 504,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_258_567",
    x1: 237,
    y1: 90.5,
    x2: 415,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_258_567",
    x1: 415,
    y1: 81.5,
    x2: 593,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_258_567",
    x1: 264,
    y1: 81.5,
    x2: 86,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_258_567",
    x1: 415,
    y1: 99.5,
    x2: 593,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD5E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_258_567",
    x1: 264,
    y1: 99.5,
    x2: 86,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLights);
export default __webpack_public_path__ + "static/media/mobile-lights.5377e70ba67976b12f8e8f57134a647e.svg";
export { ForwardRef as ReactComponent };